import { Injectable } from '@angular/core';
import {
  AutorizadorQuery,
  Banco, KeyValue,
  operacionesSap,
  ParametrosGenerales, ReporteConciBanca, ReporteConciliacion, ReporteConciQuery, StadardCode,
  TipoMovimiento, rptConciliacionTotal
} from "../../models/recuadosBancario/ParamExtracionBanca";
import {Observable} from "rxjs";
import {ApiResponse} from "../../../../model/interfaces/response";
import {HttpControllers} from "../../../../utils/Class/HttpController";
import {DATA_SOURCE} from "../../../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {QueryParams} from "../../../../model/interfaces/request";
import {ConfigEmployedPurchacedBussines} from "../../../portal-compras/pages/config/interfaces/config.interface";

@Injectable({
  providedIn: 'root'
})
export class RecaudoBancarioService {

  constructor(private httpClient: HttpClient) { }

  // Método para obtener la lista de Tipos de Movimientos
  getTiposMovimientos(): TipoMovimiento[] {
    return [
      { codigo: 100, descripcion: 'DEPOSITO' },
      { codigo: 101, descripcion: 'TRANSFERENCIA' }
    ];
  }

  getSignos(): KeyValue[] {
    return [
      { codigo: '+', descripcion: '(+)' },
      { codigo: '-', descripcion: '(-)' }
    ];
  }

  cargaOperaciones(idEmpresa: string, idBanco: string) : Observable<ApiResponse<operacionesSap[]>> {
    return new HttpControllers(this.httpClient)
      .read({
        datasource: DATA_SOURCE.VDI,
        path: `recaudo/banco/operacion/${idEmpresa}/${idBanco}`
      });
  }

  cargaCodOperaciones(idEmpresa: string, idBanco: string) {
    return new HttpControllers(this.httpClient)
      .read({
        datasource: DATA_SOURCE.VDI,
        path: `recaudo/banco/operacion/cod/${idEmpresa}/${idBanco}`
      });
  }

  cargarBancoEmpresa(idEmpresa: string) : Observable<ApiResponse<Banco[]>> {
    return new HttpControllers(this.httpClient)
      .read({
        datasource: DATA_SOURCE.VDI,
        path: `recaudo/banco/${idEmpresa}`
      });
  }

/*
  getreporteConciliacion(queryParams: QueryParams<ReporteConciQuery>) : Observable<ApiResponse<ReporteConciliacion[]>> {
    return new HttpControllers(this.httpClient)
      .read({
        datasource: DATA_SOURCE.VDI,
        path: 'cobros/obtenerReporte',
        queryParams: queryParams
      });
  }
*/
  getTotales(queryParams: QueryParams<ReporteConciQuery>) : Observable<ApiResponse<rptConciliacionTotal>> {
    return new HttpControllers(this.httpClient)
      .read({
        datasource: DATA_SOURCE.FINANCIERO,
        path: `cobros/reporteConciliacion/totales`,
        queryParams: queryParams
      });
  }

  enviarGuardarParamRecaudo(formularioValues : any) {
    return new HttpControllers(this.httpClient)
      .create({
        datasource: DATA_SOURCE.VDI,
        path: 'recaudo/config/save',
        body: formularioValues
      });
  }

  cargaParametrosGenerales(nameParam: string) : Observable<ApiResponse<ParametrosGenerales[]>> {
    return new HttpControllers(this.httpClient)
      .read({
        datasource: DATA_SOURCE.VDI,
        path: `parametros-generales-confirmacion/name/${nameParam}`
      });
  }

  actualizaParametrosGenerales(idParam : string ,formularioValues : any) : Observable<ApiResponse<ParametrosGenerales[]>> {
    return new HttpControllers(this.httpClient)
      .create({
        datasource: DATA_SOURCE.VDI,
        path: `parametros-generales-confirmacion/actualizar/${idParam}`,
        body: formularioValues
      });
  }

  actualizaParametrosGeneralesValues(formularioValues : any) : Observable<ApiResponse<ParametrosGenerales[]>> {
    return new HttpControllers(this.httpClient)
      .update({
        datasource: DATA_SOURCE.VDI,
        path: 'parametros-generales-confirmacion/actualizarValues',
        body: formularioValues
      });
  }

  getreporteConciliacion(queryParams: QueryParams<ReporteConciQuery>) : Observable<ApiResponse<ReporteConciliacion[]>> {
    return new HttpControllers(this.httpClient)
      .read({
        datasource: DATA_SOURCE.VDI,
        path: 'cobros/obtenerReporte',
        queryParams: queryParams
      });
  }


  cargaEstadosConciliacion() : Observable<ApiResponse<StadardCode[]>> {
    return new HttpControllers(this.httpClient)
      .read({
        datasource: DATA_SOURCE.VDI,
        path: 'cobros/listaEstados'
      });
  }

  cargaEstadosCobrosVdi() : Observable<ApiResponse<StadardCode[]>> {
    return new HttpControllers(this.httpClient)
      .read({
        datasource: DATA_SOURCE.FINANCIERO,
        path: 'cobros/listaEstadoCobro'
      });
  }

  getCobrosPendientes(queryParams: QueryParams<AutorizadorQuery>)  {
    return new HttpControllers(this.httpClient)
      .read({
        datasource: DATA_SOURCE.FINANCIERO,
        path: 'cobros/pendingV2',
        queryParams: queryParams
      });
  }

  cargarBancoEmpresaConfigExtracto(idEmpresa: string) : Observable<ApiResponse<Banco[]>> {
    return new HttpControllers(this.httpClient)
      .read({
        datasource: DATA_SOURCE.VDI,
        path: `recaudo/banco/extracto/${idEmpresa}`
      });
  }

 eliminarParametrosGeneralesValues(id : any) : Observable<ApiResponse<ParametrosGenerales[]>> {
    return new HttpControllers(this.httpClient)
      .delete({
        datasource: DATA_SOURCE.VDI,
        path: `recaudo/config/delete/${id}`,
      });
  }

}
